// eslint-disable-next-line import/prefer-default-export
export const GET_APPINFO = 'GET_APPINFO';
export const UPDATE_APPINFO = 'UPDATE_APPINFO';